export default __webpack_public_path__ + "img/fRXBDINR.f9236a28.svg";